<template lang="pug">
.info-tooltip(v-tooltip="info")
  img(src="@/assets/icons/information.png")
</template>

<script>
import { VTooltip } from 'v-tooltip';

VTooltip.options.defaultTrigger = `click ${VTooltip.options.defaultTrigger}`;

export default {
  directives: {
    tooltip: VTooltip,
  },
  props: {
    info: {
      required: true,
    },
  },
};
</script>

<style lang="scss">
.info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.65;
  width: 32px;
  height: 24px;
  &.sm {
    margin-left: 4px;
    margin-right: 4px;
    width: 14px;
    height: 16px;
    opacity: 0.5;
    img {
      width: 14px;
      height: 14px;
    }
  }
  img {
    width: 18px;
    height: 18px;
    filter: invert(22%) sepia(91%) saturate(1259%) hue-rotate(189deg) brightness(90%) contrast(96%);
  }
}

.tooltip {
  display: block !important;
  z-index: 10;

  .tooltip-inner {
    background: rgba(#121212, 0.95);
    // backdrop-filter: saturate(180%) blur(20px);
    color: #ffffff;
    border-radius: 16px;
    padding: 5px 10px 4px;
    box-shadow: 0 2px 12px rgba(#000000, 0.05);
    z-index: 11;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgba(#121212, 0.95);
    z-index: 13;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
